import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics 4 Measurement ID
const GA_MEASUREMENT_ID = 'G-LXCDTCKK6V';

// Check if user has accepted cookies
export const hasConsent = () => {
  return localStorage.getItem('cookieConsent') === 'accepted';
};

export const initGA = () => {
  // Only load GA if user has accepted cookies
  if (!hasConsent()) {
    console.log('Analytics disabled - user has not accepted cookies');
    return;
  }

  // Load Google Analytics script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script1);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false // We'll send page views manually
  });
};

export const logPageView = (url) => {
  if (window.gtag && hasConsent()) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
    });
  }
};

export const logEvent = (action, category, label, value) => {
  if (window.gtag && hasConsent()) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Hook to track page views
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (hasConsent()) {
      logPageView(location.pathname + location.search);
    }
  }, [location]);
};
